export default "__VITE_ASSET__BJBAoFkf__"